import { defineStore } from "pinia"
import { ref, type Ref } from "vue"
import { Machine } from "@/models/machine.model"

export const useMachineStore = defineStore("machineStore", () => {
  const machines: Ref<Machine[]> = ref([])

  return {
    machines
  }
})
